import api from 'axios'
import { URL_BACK } from '../../viariableProd'
// import swal from 'sweetalert'
import apiLogin from '../api/auth'

const path = URL_BACK + '/setUserActividad.php'
const pathCongresistaTiempoValido = URL_BACK + '/getActividadCongresistasDataValido.php?id='
const pathModulosActivos = URL_BACK + '/getValidaTiempo.php'
const pathMarqueeAndStatus = URL_BACK + '/getMarqueeAndStatus.php'
const saveTrabajoLibreActividad = URL_BACK + '/setTrabajoLibreActividad.php'
// config Basic authentication request

export default {
  async sendData (subnet, credentials) {
    return new Promise((resolve, reject) => {
      api
        .post(path + '?subnet=' + subnet, credentials)
        .then(response => {
          resolve(response)
          /* Activa bloqueo de sesion
          var tokenActivo = response.data.sesion.token
          if (tokenActivo === sessionStorage.getItem('token')) {
            resolve(response)
          } else {
            swal({
              // Cambiar el mensaje a variable
              title: 'Error',
              text: 'Se ha detectado una inconsistencia en su sesion. Debe de iniciar sesion. ',
              buttons: true,
              errorMode: true
            })
              .then(() => {
                this.cleanToken()
              })
          }
          */
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getActividadCongresistaTiempoValido (subnet, credentials) {
    const url = pathCongresistaTiempoValido + credentials + '&subnet=' + subnet
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getModulosActivos (subnet) {
    const url = pathModulosActivos + '?subnet=' + subnet
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getMarqueeAndStatus (subnet) {
    const url = pathMarqueeAndStatus + '?subnet=' + subnet
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  async cleanToken () {
    await apiLogin
      .deleteTokenSesion({email: sessionStorage.getItem('email'), token: localStorage.getItem('token')})
      .then(x => {
        console.log(x)
        localStorage.removeItem('token')
        sessionStorage.removeItem('token')
        sessionStorage.removeItem('email')
        location.href = '/' + localStorage.getItem('subnet')
      })
  },
  async saveTrabajoLibreActividad (subnet, trabajoLibreId, meta) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('trabajoLibreId', trabajoLibreId)
      formData.append('meta', JSON.stringify(meta))
      api
        .post(saveTrabajoLibreActividad + '?subnet=' + subnet, formData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/userActividad.js